import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import declare from "dojo/_base/declare";

export = declare(Action, {
	/**
	 * @override
	 * Only allow if Proof is not locked and one of the following: 
     * 1. DocumentRevision.State is Proofing and not uploading
     * 2. DocumentRevision.State is Approved and ProofStatus is not empty
     * 3. DocumentRevision.State is Draft and ProofStatus is not empty and not new version available 
	 */
	hasAccess(ctx: Context) {
		const currentRevision = ctx.cache.getNode(ctx.getNode().CurrentRevision);
		const proofStatus = currentRevision.ProofStatus;
		const state = currentRevision.State;

		return this.inherited(arguments) && currentRevision.ProofIsLocked === false &&
		((proofStatus !== "ProofDecisionStatus:Uploading" && state === "Revision.State:PROOFING") ||
        (proofStatus !== "ProofDecisionStatus:" && state === "Revision.State:APPROVED") ||
        (proofStatus !== "ProofDecisionStatus:" && proofStatus !== "ProofDecisionStatus:NewVersionAvailable" && state === "Revision.State:DRAFT"));
	},
});